export const appearancePreferences = ['system', 'light', 'dark'] as const;
export type AppearancePreference = (typeof appearancePreferences)[number];

const storageKey = 'ponchik:appearance';

export function resolveAppearance(
  preference: AppearancePreference,
  telegramScheme: 'light' | 'dark' | undefined,
): 'light' | 'dark' {
  return preference === 'system' ? (telegramScheme ?? 'light') : preference;
}

export function readAppearancePreference(): AppearancePreference {
  try {
    const value = window.localStorage.getItem(storageKey);
    return appearancePreferences.includes(value as AppearancePreference)
      ? (value as AppearancePreference)
      : 'system';
  } catch {
    return 'system';
  }
}

export function applyAppearance(
  preference: AppearancePreference,
  telegramScheme: 'light' | 'dark' | undefined,
): 'light' | 'dark' {
  const resolved = resolveAppearance(preference, telegramScheme);
  document.documentElement.dataset.theme = resolved;
  return resolved;
}

export function applyStoredAppearance(telegramScheme: 'light' | 'dark' | undefined) {
  return applyAppearance(readAppearancePreference(), telegramScheme);
}

export function saveAppearancePreference(
  preference: AppearancePreference,
  telegramScheme: 'light' | 'dark' | undefined,
) {
  try {
    window.localStorage.setItem(storageKey, preference);
  } catch {
    // Appearance is a local convenience only; the app remains usable without storage access.
  }
  return applyAppearance(preference, telegramScheme);
}
